import { foldTurkish } from './mrz-parser';

const words = (value?: string | null): string[] =>
  foldTurkish(value ?? '')
    .replace(/[^A-Z\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean);

/**
 * Kimlikten okunan ad seçili carinin adıyla uyuşuyor mu (masak-kimlik-ocr.md §5.6, K7 — uyuşmazsa
 * kayıt engellenir). Türkçe karakter, büyük/küçük harf ve sözcük sırası farkı uyuşmazlık sayılmaz.
 * Uyuşması için: kimlikteki soyadın her sözcüğü carinin adında geçmeli VE carinin adındaki her
 * sözcük kimlikteki ad + soyad içinde bulunmalı (cari "AYŞE YILMAZ", kimlik "AYŞE GÜL YILMAZ" → uyuşur).
 */
export function identityNameMatchesCustomer(firstName?: string, lastName?: string, customerName?: string): boolean {
  const surname = words(lastName);
  const identity = new Set([...words(firstName), ...surname]);
  const card = words(customerName);
  if (!surname.length || !card.length) return false;
  const cardSet = new Set(card);
  return surname.every((w) => cardSet.has(w)) && card.every((w) => identity.has(w));
}
